import { GET_RECONCILIATION } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const getReconciliation = (payload) => {
  return apiInstance.post(GET_RECONCILIATION, payload);
};
